import { useTranslation } from 'react-i18next';
import Icon from '../../../components/AppIcon';

const FeaturesSection = () => {
  const { t } = useTranslation();

  const features = [
    {
      id: 'security',
      icon: 'ShieldCheck',
      titleKey: 'features.security_title',
      descKey: 'features.security_desc'
    },
    {
      id: 'speed',
      icon: 'Zap',
      titleKey: 'features.speed_title',
      descKey: 'features.speed_desc'
    },
    {
      id: 'privacy',
      icon: 'Lock',
      titleKey: 'features.privacy_title',
      descKey: 'features.privacy_desc'
    },
    {
      id: 'support',
      icon: 'Headphones',
      titleKey: 'features.support_title',
      descKey: 'features.support_desc'
    }
  ];

  return (
    <section className="w-full px-4 md:px-6 lg:px-8 py-12 md:py-16 lg:py-20 bg-muted/30">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10 md:mb-12 lg:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4 lg:mb-5">
            {t('features.main_title')}
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-muted-foreground max-w-3xl mx-auto leading-relaxed">
            {t('features.main_subtitle')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 md:gap-7 lg:gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-card rounded-xl p-6 md:p-7 lg:p-8 border border-border shadow-elevation-1 hover:shadow-elevation-2 transition-all duration-250 hover:-translate-y-1"
            >
              <div className="flex items-center justify-center w-14 h-14 md:w-16 md:h-16 lg:w-18 lg:h-18 rounded-xl bg-primary/10 mb-5 md:mb-6 lg:mb-7">
                <Icon name={feature.icon} size={28} color="var(--color-primary)" className="w-7 h-7 md:w-8 md:h-8" />
              </div>
              <h3 className="text-lg md:text-xl lg:text-2xl font-semibold text-foreground mb-3 md:mb-4">
                {t(feature.titleKey)}
              </h3>
              <p className="text-sm md:text-base text-muted-foreground leading-relaxed">
                {t(feature.descKey)}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;